export const EvaluationTrainingColdCriterionCategory = {
    path: '/evaluation_training_cold_criterion_category',
    name: 'evaluation_training_cold_criterion_category',
    component: () => import('@/views/DataSelect/DataSelectPage.vue'),
    props: {externType: 'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY'},
    children: [
        {
            path: '/evaluation_training_cold_criterion_category/add',
            name: 'evaluation_training_cold_criterion_category.add',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {addAction: true, externType: 'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY'}
        },
        {
            path: '/evaluation_training_cold_criterion_category/edit/:id',
            name: 'evaluation_training_cold_criterion_category.edit',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {updateAction: true, externType: 'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY'}
        },
        {
            path: '/evaluation_training_cold_criterion_category/delete/:id',
            name: 'evaluation_training_cold_criterion_category.delete',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {deleteAction: true, externType: 'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY'}
        },
        {
            path: '/evaluation_training_cold_criterion_category/view/:id',
            name: 'evaluation_training_cold_criterion_category.view',
            component: () => import('@/views/DataSelect/Form/DataSelectForm.vue'),
            props: {viewAction: true, externType: 'EVALUATION_TRAINING_COLD_CRITERION_CATEGORY'}
        },
    ]
}